import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable( {
  providedIn: 'root',
} )
export class CommonService {

  constructor(
    private http: HttpService,
  ) { }

  /**
   * @description Calculadora
   * @param data Objeto weight
   */
  calculator( data: string ): Observable<any> {
    return this.http.post( `calculator`, data );
  }

  /**
   * @description Prealertar
   * @param data Detalle del paquete
   */
  prealert( data: any ): Observable<any> {
    return this.http.post( `package`, data );
  }

  /**
   * @description Rastreo de paquete
   * @param track Numero de tracking
   */
  tracking( data: any ): Observable<any> {
    return this.http.get( `package?searchCode=${data.searchCode}` );
  }
}
